module.exports = __webpack_public_path__ + "static/media/diligence-logo.a392bbad.svg";